import type { DropdownMenuOption } from '@kandji-inc/nectar-ui';
import { i18n } from 'i18n';
import constants from '../../../../common/constants';
import type { ThreatGroupUnion } from '../../../../threat.types';

const getRowActionOptions = (item: ThreatGroupUnion) => {
  const actionOptions: DropdownMenuOption[] = [
    {
      label: i18n.t('Search VirusTotal'),
      icon: 'virus-total',
      onClick: /* istanbul ignore next -- Linking */ () =>
        window.open(`${constants.VIRUS_TOTAL_URL}${item.threat_id}`),
    },
  ];

  return actionOptions;
};

export default getRowActionOptions;
